import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Zap, Users, Trophy, Clock, CheckCircle2, BarChart3, Smartphone, Globe, CreditCard, Shield, Activity, TrendingUp, PieChart, FileCheck } from 'lucide-react';
import ServiceCardGrid from '../../components/custom/ServiceCardGrid/ServiceCardGrid';

function ServicosPage() {
  return (
    <div className="bg-white min-h-screen font-sans text-slate-900">

      {/* Hero Section - High Impact Ecosystem Showcase */}
      <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-40 overflow-hidden bg-white">
        {/* Background - Elegant Grid & Mesh */}
        <div className="absolute inset-0 z-0 opacity-[0.4]"
          style={{
            backgroundImage: 'linear-gradient(#f1f5f9 1px, transparent 1px), linear-gradient(90deg, #f1f5f9 1px, transparent 1px)',
            backgroundSize: '40px 40px'
          }}>
        </div>

        {/* Dynamic Glow Accents */}
        <div className="absolute top-0 right-0 w-[800px] h-[600px] bg-purple-500/10 rounded-full blur-[120px] -z-10 animate-pulse flex justify-center" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[400px] bg-indigo-500/5 rounded-full blur-[100px] -z-10" />

        <div className="container mx-auto px-4 relative z-10">
          <div className="flex flex-col items-center justify-center text-center">
            {/* Copy & Value Prop */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="max-w-4xl"
            >
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-slate-900 mb-8 tracking-tighter leading-[0.95]">
                Serviços<br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#8B5CF6] via-indigo-500 to-purple-600">
                  LUKOS
                </span>
              </h1>

              <p className="text-lg md:text-xl text-slate-500 mb-12 leading-relaxed font-medium max-w-2xl mx-auto">
                Uma plataforma completa que conecta pista, conveniência e financeiro. Antecipe o futuro com a gestão inteligente da Lukos.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
                <button className="px-10 py-5 bg-[#8B5CF6] text-white font-black rounded-2xl shadow-2xl shadow-purple-500/30 hover:bg-[#7c4dff] hover:-translate-y-1 transition-all w-full sm:w-auto uppercase tracking-widest text-sm">
                  Consultar Soluções
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ── GRID DE SERVIÇOS ── */}
      <ServiceCardGrid />

      {/* Final Branding / CTA - Light Corporate */}
      <section className="py-32 text-center bg-white relative overflow-hidden border-t border-slate-100">
        <div className="absolute inset-0 z-0 opacity-[0.4]"
          style={{
            backgroundImage: 'linear-gradient(#e2e8f0 1px, transparent 1px), linear-gradient(90deg, #e2e8f0 1px, transparent 1px)',
            backgroundSize: '32px 32px'
          }}>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-black text-slate-900 mb-8 tracking-tight leading-tight">
              Pronto para <span className="text-[#8B5CF6]">elevar o nível</span> <br />da sua gestão?
            </h2>
            <p className="text-lg text-slate-500 mb-12 max-w-2xl mx-auto">
              Junte-se a mais de 1.500 postos que já transformaram seus resultados com a tecnologia Lukos.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <button className="px-10 py-5 bg-[#8B5CF6] text-white text-lg font-bold rounded-2xl hover:bg-[#7c4dff] hover:scale-105 transition-all shadow-xl shadow-purple-500/20">
                FALAR COM UM ESPECIALISTA
              </button>
              <div className="flex items-center gap-2 text-slate-500 font-medium text-sm">
                <CheckCircle2 className="w-4 h-4 text-green-500" />
                <span>Implantação Acompanhada</span>
              </div>
              <div className="flex items-center gap-2 text-slate-500 font-medium text-sm">
                <CheckCircle2 className="w-4 h-4 text-green-500" />
                <span>Suporte 24h</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ServicosPage;
